import { useState, useEffect } from 'react';

let currentPlatform = 'whatsapp';
const listeners = new Set();

export const selectedPlatformAtom = {
  get: () => currentPlatform,
  set: (newPlatform) => {
    currentPlatform = newPlatform;
    listeners.forEach((listener) => listener(currentPlatform));
  },
  subscribe: (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useSelectedPlatform() {
  const [platform, setPlatform] = useState(selectedPlatformAtom.get());

  useEffect(() => {
    const unsubscribe = selectedPlatformAtom.subscribe(setPlatform);
    return unsubscribe;
  }, []);

  return [platform, selectedPlatformAtom.set];
}
